import {useEffect} from "react";
import {api,getSessionGeneration,sessionExpired,setSessionMonitoring} from "./api";

// One cookie session spans all tabs in the browser profile. Every tab subscribes
// so revocation closes even an idle Controller page; no token enters JS storage.
export function useSessionPresence(authenticated:boolean|null){
 useEffect(()=>{
  setSessionMonitoring(Boolean(authenticated));
  if(!authenticated)return;
  let active=true;
  const generation=getSessionGeneration();
  const heartbeat=()=>{if(active)void api("/me/sessions/heartbeat",{method:"POST"}).catch(()=>undefined);};
  const events=new EventSource("/api/ui/v1/me/sessions/events",{withCredentials:true});
  events.addEventListener("revoked",event=>{if(!active||generation!==getSessionGeneration())return;let reason="expired";try{reason=JSON.parse((event as MessageEvent).data).reason||reason;}catch{}sessionExpired(reason);});
  events.addEventListener("account",()=>{if(active&&generation===getSessionGeneration()){dispatchEvent(new Event("layla:account-refresh"));dispatchEvent(new Event("layla:account-updated"));}});
  events.onerror=()=>{if(active)heartbeat();};
  const interval=setInterval(heartbeat,30000);
  const visibility=()=>{if(document.visibilityState==="visible")heartbeat();};
  document.addEventListener("visibilitychange",visibility);
  addEventListener("online",heartbeat);
  heartbeat();
  return()=>{active=false;setSessionMonitoring(false);clearInterval(interval);events.close();document.removeEventListener("visibilitychange",visibility);removeEventListener("online",heartbeat);};
 },[authenticated]);
}
